/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CandidateCountOfferPerState model module.
 * @module model/CandidateCountOfferPerState
 * @version v1
 */
class CandidateCountOfferPerState {
    /**
     * Constructs a new <code>CandidateCountOfferPerState</code>.
     * Item para mostrar un estado y su cantidad de ofertas
     * @alias module:model/CandidateCountOfferPerState
     */
    constructor() { 
        
        CandidateCountOfferPerState.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CandidateCountOfferPerState</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CandidateCountOfferPerState} obj Optional instance to populate.
     * @return {module:model/CandidateCountOfferPerState} The populated <code>CandidateCountOfferPerState</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CandidateCountOfferPerState();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
CandidateCountOfferPerState.prototype['id'] = undefined;

/**
 * @member {String} name
 */
CandidateCountOfferPerState.prototype['name'] = undefined;

/**
 * @member {Number} count
 */
CandidateCountOfferPerState.prototype['count'] = undefined;






export default CandidateCountOfferPerState;

